import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Event, Celebration, StaffLocationDetail } from '../models/event.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CelebrationService {
  private readonly API_URL = environment.API_URL;
  constructor(private http: HttpClient) {}

  /**
   * Busca eventos em andamento
   */
  getOngoingCelebrations(): Observable<Event[]> {
    return this.http.get<Event[]>(`${this.API_URL}/bpv/celebrations/ongoing`);
  }

  /**
   * Busca detalhes de uma celebração específica
   */
  getCelebrationById(celebrationUuid: string): Observable<Celebration> {
    return this.http.get<Celebration>(`${this.API_URL}/bpv/celebrations/${celebrationUuid}`);
  }  /**
   * Busca staff de uma celebrationJobLocation por ID
   */
  getLocationStaff(celebrationJobLocationId: string): Observable<StaffLocationDetail> {
    return this.http.get<StaffLocationDetail>(`${this.API_URL}/bpv/celebrationJobLocations/${celebrationJobLocationId}`);
  }
}
